// Generated by ui/scripts/build-cognito-config.mjs from config.yaml.
// Do not edit by hand. Re-runs every build.

export const COGNITO = {
  region: "ca-central-1",
  userPoolId: "ca-central-1_Ag46d60hx",
  clientId: "3l53pr7jgmmqlo53g2fv32kh2f",
  domain: "bluf-onboard-nonprod.auth.ca-central-1.amazoncognito.com",
} as const;
